/**
 * @description 上传文件
 * @create time 2023/11/22
 */

const { uploadFile } = require("@/api/upload");

export default function upload (file, options) {
    return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('file', file)

        if (options) {
            for (const key in options) {
                formData.append(key, options[key])
            }
        }

        uploadFile(formData).then(result => {
            if (result.code === 1) resolve(result.data)
        }).catch(error => {
            reject(new Error(error.message))
        })
    })
}
